import { render, staticRenderFns } from "./Bandeja.vue?vue&type=template&id=355b3fd6"
import script from "./Bandeja.vue?vue&type=script&lang=js"
export * from "./Bandeja.vue?vue&type=script&lang=js"
import style0 from "./Bandeja.vue?vue&type=style&index=0&id=355b3fd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports